module.exports = __webpack_public_path__ + "img/blog-cv-3.47a86119.webp";